// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.0-beta.bae7d5449',
  revision: 'bae7d5449',
  branch: 'develop',
  date: 'Fri, 15 May 2026 14:24:00 GMT'
};